import React from "react";
import './Category_Subcategory_Card.css'

const Category_Subcategory_Card = (
  {
  content,
  image,
  imgClassName,
  className,
  textClassName,
  alt,
}
) => {
  return (
     <section className="Category_Subcategory_Card">
      <div className={className}>
        <div className="img_hodler">

        <img src={image} className={imgClassName} alt={alt} />
        </div>
        <div className="text-holder">
          <p className={textClassName}>{content}</p>
        </div>
      </div>
    </section>
  )
}

export default Category_Subcategory_Card

